import { render } from "./VideoBtn.vue?vue&type=template&id=608a8111&scoped=true"
import script from "./VideoBtn.vue?vue&type=script&lang=js"
export * from "./VideoBtn.vue?vue&type=script&lang=js"

import "./VideoBtn.vue?vue&type=style&index=0&id=608a8111&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608a8111"]])

export default __exports__